<template>
  <div id="chart-container" style="width: 100%; height: 330px;"></div>
</template>

<script>
import { onMounted, onBeforeDestroy } from "vue";
import * as echarts from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
} from "echarts/components";

echarts.use([
  CanvasRenderer,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  BarChart,
  GridComponent,
]);

export default {
  name: "EchartsBarChart",
  data() {
    return {
      myChart: null,
    };
  },
  mounted() {
    this.initChart();
  },
  props: {
    option: Object,
  },
  methods: {
    initChart() {
      this.myChart = echarts.init(document.getElementById("chart-container"));
      this.updateChart();
      window.addEventListener("resize", this.handleResize);
    },
    updateChart() {
      this.myChart.setOption(this.option);
    },
    handleResize() {
      this.myChart.resize();
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.myChart) {
      this.myChart.dispose();
    }
  },
  watch: {
    option: {
      handler: function() {
        this.initChart();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
#chart-container {
  width: 100%;
  height: 400px;
}
</style>
